import { OctreeLoader } from './OctreeLoader';

import type { XhrRequest } from './types';
import type { GetAssetUrlFunctionType } from '../types';

export async function loadOctree(
  metadataUrl: string,
  getUrl: GetAssetUrlFunctionType,
  xhrRequest: XhrRequest,
) {
  const loader = new OctreeLoader();
  const { geometry } = await loader.load(metadataUrl, getUrl, xhrRequest);
  return geometry;
}
